import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {UtilService} from '../../services/util/util.service';

export type HeightMultiplier = 5 | 10 | 20;
export const HeightMultiplierEnum = {
  Short: 5 as HeightMultiplier,
  Medium: 10 as HeightMultiplier,
  High: 20 as HeightMultiplier
};

@Component({
  selector: 'app-html-more',
  templateUrl: './html-more.component.html',
  styleUrls: ['./html-more.component.scss']
})
export class HtmlMoreComponent {
  @ViewChild('htmlBox') htmlBox: ElementRef<HTMLElement>;

  public htmlValue: SafeHtml;
  @Input() public set html(value: string) {
    this.htmlValue = this.sanitizer.bypassSecurityTrustHtml(value) || '';
  }
  @Input() public height: HeightMultiplier = HeightMultiplierEnum.Medium;
  public collapsed = true;
  public HeightMultiplierEnum = HeightMultiplierEnum;

  constructor(private sanitizer: DomSanitizer,
              public utilService: UtilService) {}

  public get getHeight(): number {
    return this.htmlBox?.nativeElement?.clientHeight || 0;
  }
}
